module.exports = __webpack_public_path__ + "img/bg-drop.47286853.svg";